<script setup>
import {ref, reactive} from 'vue';
import YTCard from "@/components/YTCard/YTCard.vue";
import YTBoxUpload from "@/components/YTBoxUpload/index.vue"
import router from "@/router/index.js";

// 会员等级枚举
const memberLevelEnum = [
  {
    label: "普通",
    value: "REGULAR"
  },
  {
    label: "VIP",
    value: "VIP"
  },
  {
    label: "SVIP",
    value: "SVIP"
  },
  {
    label: "Premier会员",
    value: "PREMIER"
  }
]
// 门禁类型枚举
const accessTypeEnum = [
  {
    label: "海康",
    value: 1
  }
]
// 加载状态
const loading = ref(false)
// 表单锚点
const ruleFormRef = ref()
// 表单信息
const ruleForm = reactive({
  accessInfo: [
    {
      name: null,
      type: 1,
      apiUrl: "",
      memberLevel: "REGULAR"
    }
  ],
  time: null,
  coast: 0
})
// 表单校验规则
const rules = {

}
// 处理添加门禁
const handleAddAccess = () => {
  ruleForm.accessInfo.push({
    name: null,
    type: 1,
    apiUrl: "",
    memberLevel: "REGULAR"
  })
}
// 处理删除门禁
const handleRemoveAccess = (index) => {
  ruleForm.accessInfo.splice(index, 1)
}

// 处理添加场馆信息
const submit = async () => {
  ruleFormRef.value.validate(async (valid) => {
    if (valid) {
      loading.value = true

      loading.value = false
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
</script>

<template>
  <div class="container_box">
    <div class="flex_left">
      <el-form
          ref="ruleFormRef"
          style="width: 100%"
          :model="ruleForm"
          :rules="rules"
          label-width="auto"
          class="demo-ruleForm"
          size="large"
          status-icon
          v-loading="loading"
      >
        <YTCard :title="'场馆名称'" :is-show-divider="false">
          <template #container>
            <el-form-item label="门禁：">
              <div class="w-100">
                <div v-if="ruleForm.accessInfo.length > 0">
                  <div class="flex_left mg_b_2" v-for="(item, index) in ruleForm.accessInfo">
                    <el-input class="mg_r_2" v-model="item.name" placeholder="门禁名称" style="width: 200px;"></el-input>
                    <el-select style="width: 150px;" disabled class="mg_r_2" v-model="item.type" placeholder="请选择">
                      <el-option
                          v-for="item in accessTypeEnum"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                    <el-input class="mg_r_2" v-model="item.apiUrl" placeholder="门禁接口地址" style="width: 350px;"></el-input>
                    <el-select style="width: 150px;" class="mg_r_2" v-model="item.memberLevel" placeholder="请选择">
                      <el-option
                          v-for="item in memberLevelEnum"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                      </el-option>
                    </el-select>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除"
                        placement="right">
                      <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveAccess(index)"></v-icon>
                    </el-tooltip>
                  </div>
                </div>
                <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddAccess"></v-icon>
                <span>添加门禁信息。</span>
              </div>
            </el-form-item>
            <el-form-item label="时间单位：">
              <div class="flex_left">
                <el-input-number class="mg_r_1" placeholder="时间" v-model="ruleForm.time" :min="0" :precision="0"></el-input-number><div class="mg_r_1">分钟</div>
                <el-input-number class="mg_r_1" placeholder="费用" v-model="ruleForm.coast" :min="0" :precision="2"></el-input-number><div class="mg_r_2">元</div>
                <div>用户预定场地的时间。必须是时间单位的整倍数。例如时间单位是15分钟，用户只能预定15、30、45...</div>
              </div>
            </el-form-item>
            <el-form-item label="场馆布局：">
              <YTBoxUpload ref="boxUploadRef" :prePath="'goods/images/'" :width="900" :height="400" :limit="4" :file-size="1"></YTBoxUpload>
            </el-form-item>
            <v-row>
              <v-col cols="4">
                <v-row>
                  <v-col cols="6">
                    <v-btn @click="router.back()">取消</v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn color="primary" @click="submit">保存</v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </YTCard>
      </el-form>
    </div>
  </div>
</template>

<style scoped>

</style>